import { render, staticRenderFns } from "./ReporteLeadsTuSeguro.vue?vue&type=template&id=796dad62"
import script from "./ReporteLeadsTuSeguro.vue?vue&type=script&lang=js"
export * from "./ReporteLeadsTuSeguro.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports